module.exports = __webpack_public_path__ + "img/lg_ring_y_i_0_1@3x.b68d2759.png";